import { gql } from '@apollo/client';


export const GET_PERSON_ATTACHMENTS = gql`
  query GET_PERSON_ATTACHMENTS($personId: ID!, $originatorId: ID!){
    getPerson(personId: $personId, originatorId: $originatorId) {
      id
      genericAttachments {
        attachmentType {
          id
          name
        }
        confidential
          dataFileName
          dataUrl
          dataUrlWrapper
          description
        incident {
          id
          ori {
            id
          }
        }
        employee {
          id
          personalAttribute {
            lastName
            firstName
          }
          deptAttribute {
            badge
            ori {
              id
              abbreviation
            }
          }
        }
        id
        lastUpdated
        ownerName
      }
    }
  }
`;


